import { useBandContext } from "Bands/contexts";
import { BAND_PATHS } from "Bands/router";
import { FC } from "react";
import { Redirect } from "react-router-dom";

import { buildUrl, useScrollToHashOnFirstRender } from "shared/utils";

export const BandAssetsPage: FC = () => {
  useScrollToHashOnFirstRender();

  const { bandId } = useBandContext();

  if (!bandId) return null;

  return (
    <Redirect
      to={buildUrl(BAND_PATHS.BAND_ASSETS_CONTACTS, {
        bandId,
      })}
    />
  );
};
